import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const WorkflowScheduleLogGetList = createAsyncThunk(
    "WorkflowScheduleLogGetList",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GET_WORKFLOW_SCHEDULE_LOG_LIST,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);

            return response;
        } catch (error) { }
    }
);

export const WorkflowScheduleMachineLogGetList = createAsyncThunk(
    "WorkflowScheduleMachineLogGetList",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GET_WORKFLOW_SCHEDULE_MACHINE_LOG_LIST,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);

            return response;
        } catch (error) { }
    }
);

export const SandboxMachineLogDetails = createAsyncThunk(
    "SandboxMachineLogDetails",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GET_SANDBOXMACHINELOGDETAILS,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);

            return response;
        } catch (error) { }
    }
);

export const WorkflowScheduleMachineLogGetListByWorkflowulogid = createAsyncThunk(
    "WorkflowScheduleMachineLogGetListByWorkflowulogid",
    async (data, { dispatch }) => {
        try {
            let resData = await apiCall(
                {
                    method: "POST",
                    url: API_URL.BASEURL + API_URL.GET_WORKFLOW_SCHEDULE_MACHINE_LOG_LIST_BYWORKFLOWULOGID,
                    body: data,
                },
                true
            );
            let response = apiResponse(false, resData);

            return response;
        } catch (error) { }
    }
);

const initialState = {
    WorkflowScheduleLogGetListData: {
        data: null,
        error: null,
    },
    WorkflowScheduleMachineLogGetListData: {
        data: null,
        error: null,
    },
    WorkflowScheduleMachineLogGetListByWorkflowulogidData: {
        data: null,
        error: null,
    },
    SandboxMachineLogDetailsData: {
        data: null,
        error: null,
    },
};

const AllLogSlice = createSlice({
    name: "ALLLOGSLICE",
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(WorkflowScheduleLogGetList.fulfilled, (state, action) => {
                state.WorkflowScheduleLogGetListData.data = action.payload;
            })
            .addCase(WorkflowScheduleLogGetList.rejected, (state, action) => {
                state.WorkflowScheduleLogGetListData.error = action.error.message;
            })
            .addCase(WorkflowScheduleMachineLogGetList.fulfilled, (state, action) => {
                state.WorkflowScheduleMachineLogGetListData.data = action.payload;
            })
            .addCase(WorkflowScheduleMachineLogGetList.rejected, (state, action) => {
                state.WorkflowScheduleMachineLogGetListData.error =
                    action.error.message;
            })
            .addCase(WorkflowScheduleMachineLogGetListByWorkflowulogid.fulfilled, (state, action) => {
                state.WorkflowScheduleMachineLogGetListByWorkflowulogidData.data = action.payload;
            })
            .addCase(WorkflowScheduleMachineLogGetListByWorkflowulogid.rejected, (state, action) => {
                state.WorkflowScheduleMachineLogGetListByWorkflowulogidData.error =
                    action.error.message;
            })
            .addCase(SandboxMachineLogDetails.fulfilled, (state, action) => {
                state.SandboxMachineLogDetailsData.data = action.payload;
            })
            .addCase(SandboxMachineLogDetails.rejected, (state, action) => {
                state.SandboxMachineLogDetailsData.error =
                    action.error.message;
            });
    },
});

export default AllLogSlice.reducer;
